import React from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import { usePermissions } from '@appic/hooks'

interface RouteGuardProps {
  children: React.ReactNode
}

export const RouteGuard: React.FC<RouteGuardProps> = ({ children }) => {
  const location = useLocation()
  const { isSuperadmin, canAccessRoute } = usePermissions()

  // Non-superadmin users can only access /scout/* paths
  if (!isSuperadmin && !location.pathname.startsWith('/scout')) {
    return <Navigate to="/scout/wochenplanung" replace />
  }

  // Superadmin users have full access
  if (isSuperadmin) {
    return <>{children}</>
  }

  // Check route-level permissions for non-superadmin
  if (!canAccessRoute(location.pathname)) {
    return <Navigate to="/scout/wochenplanung" replace />
  }

  return <>{children}</>
}